$(function() {
  document.addEventListener('Neos.PageLoaded',function(event) {
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
  })
})
